import { Spinner } from 'react-bootstrap';
import { ArrowUpRight } from 'lucide-react';

import { ExternalTool } from '../../../config/external-tools';
import { ListItem, ListItemIcon, ListItemName, ListItemDescription, SsoBadge, OpeningRow } from '../styles';

interface ToolRowProps {
  tool: ExternalTool;
  isOpening: boolean;
  onOpen: (tool: ExternalTool) => void;
}

export const ToolRow = ({ tool, isOpening, onOpen }: ToolRowProps) => {
  if (isOpening) {
    return (
      <OpeningRow>
        <Spinner animation="border" size="sm" style={{ color: '#7c3aed', width: 16, height: 16 }} />
        Abriendo {tool.name}...
      </OpeningRow>
    );
  }

  return (
    <ListItem
      role="button"
      tabIndex={0}
      onClick={() => onOpen(tool)}
      onKeyDown={(e) => e.key === 'Enter' && onOpen(tool)}
    >
      <ListItemIcon $color="#7c3aed">
        <ArrowUpRight size={15} strokeWidth={1.75} />
      </ListItemIcon>
      <ListItemName>{tool.name}</ListItemName>
      <ListItemDescription>{tool.description}</ListItemDescription>
      <SsoBadge>SSO</SsoBadge>
    </ListItem>
  );
};
